<template>
  <div>
    <table class="table table-hover table-sm table-striped">
      <thead class="t-head thead-light text-center">
        <tr>
          <td colspan="2">{{ item.label }}</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <b v-translate>Hotel: </b>
          </td>
          <td>{{ item.hotel_info.hotel }}</td>
        </tr>
        <tr>
          <td>
            <b v-translate>Room category: </b>
          </td>
          <td>{{ item.hotel_info.room_category }} </td>
        </tr>
        <tr>
          <td>
            <b v-translate>Check in: </b>
          </td>
          <td>{{ checkIn }}</td>
        </tr>
        <tr>
          <td>
            <b v-translate>Duration: </b>
          </td>
          <td>{{ item.duration }} nopti </td>
        </tr>
        <tr>
          <td>
            <b v-translate>Check out:</b>
          </td>
          <td>{{ checkOut }}</td>
        </tr>
        <tr>
          <td>
            <b v-translate>Meals:</b>
          </td>
          <td> {{ item.hotel_info.meal_basis }}</td>
        </tr>
        <tr>
          <td>
            <b v-translate>Room:</b>
          </td>
          <td>
            {{ rooms }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'HotelItemInfo',
  props: ['item'],
  computed: {
    checkIn () {
      return moment(this.item.start_date).format('DD-MM-YYYY')
    },
    checkOut () {
      return moment(this.item.end_date).format('DD-MM-YYYY')
    },
    rooms () {
      const rooms = this.item.hotel_info.rooms.reduce((acc, el) => {
        const elIndex = acc.findIndex(exEl => exEl.name === el.name)
        if (elIndex >= 0) acc[elIndex].count++
        else acc.push({ name: el.name, count: 1 })
        return acc
      }, [])
      return rooms.reduce((acc, el) => acc + (acc ? ', ' : '') + (el.count + ' x ' + el.name), '')
    }
  }
}
</script>
